/**
 * Create the store with dynamic reducers
 */

import { createStore, applyMiddleware, compose } from 'redux';
import { fromJS } from 'immutable';
import { routerMiddleware } from 'connected-react-router/immutable';
import defaultHistory from 'utils/history';
import createReducer from './reducers';
import updateFieldNameMiddleware from './containers/FormBuilder/middleware/updateFieldNameMiddleware';
import loadDropdownMiddleware from './containers/FormBuilder/middleware/loadDropdownMiddleware';

export default function configureStore(history = defaultHistory, initialState = {}) {
  let composeEnhancers = compose;

  // if (process.env.NODE_ENV !== 'production' && typeof window === 'object') {
  /* eslint-disable no-underscore-dangle */
  if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) { composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}); }
  /* eslint-enable */
  // }
  const middlewares = [
    routerMiddleware(history),
    updateFieldNameMiddleware,
    loadDropdownMiddleware,
  ];

  const enhancers = [
    applyMiddleware(...middlewares),
  ];
  const store = createStore(
    createReducer({ history }),
    fromJS(initialState),
    composeEnhancers(...enhancers)
  );

  store.injectedReducers = {}; // Reducer registry

  // Make reducers hot reloadable, see http://mxs.is/googmo
  /* istanbul ignore next */
  if (module.hot) {
    module.hot.accept('./reducers', () => {
      store.replaceReducer(createReducer({ injectedReducers: store.injectedReducers }));
    });
  }

  return store;
}
